import React from 'react';
import { connect } from 'react-redux';
import { ProfileDetail as ProfileComp } from "dsilo-ui-components"

import { makeStyles } from '@material-ui/styles';

import { PUBLIC_PATH } from 'constants/index';
import AppHeader from '../AppsDashboard/AppHeader';

import { updateProfile, changePassword, clearReduxDataOfCurrentComponentLogin} from '../../store/actions';
import { getOrgDetails } from "../../store/actions/org"

const Profile = props => {
	return (
		<AppHeader>
			<ProfileComp
				orgPath={`/org`}
				history={props.history}
				appId={props.match.params.appid}
				//Actions
				updateProfile={props.updateProfile}
				getOrgDetails={props.getOrgDetails}
				changePassword={props.changePassword}
				clearReduxDataOfCurrentComponentLogin={props.clearReduxDataOfCurrentComponentLogin}
				// Redux states
				org={props.org}
				login={props.login}
				user={{ token: localStorage.getItem('jwt_access_token'), ...props.user }}
				resetPath={`/${PUBLIC_PATH}resetpassword/${localStorage.getItem('jwt_access_token')}`}
			/>
		</AppHeader>
	);
}

const mapDispatchToProps = {
	updateProfile,
	getOrgDetails,
	changePassword,
	clearReduxDataOfCurrentComponentLogin
}

const mapStateToProps = state => {
	return {
		org: state.org,
		user: state.user,
		login: state.login
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);